import { NgModule } from "@angular/core";
import {
  provideHttpClient,
  withInterceptors,
  withXhr,
} from "@angular/common/http";
import { tokenInterceptor } from "./token.interceptor";
import { impersonateInterceptor } from "./impersonate.interceptor";
import { unauthorizedInterceptor } from "./unauthorized.interceptor";
import { AuthHttpConfig } from "./auth-http-config";
import { msalInterceptor } from "../msal/msal.interceptor";

@NgModule({
  providers: [
    AuthHttpConfig,
    provideHttpClient(
      withXhr(),
      withInterceptors([
        tokenInterceptor,
        impersonateInterceptor,
        msalInterceptor,
        unauthorizedInterceptor,
      ]),
    ),
  ],
  declarations: [],
})
export class AuthorizationModule {}
